import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AppMessageService {

    /*
        messageType VALUES
        - success
        - error
        - info
    */
    showAppMessage(message:string, messageType:string):void {
        const form = document.querySelector("#app-message");
        if (form !== null) {
            form.classList.remove("show");
            form.innerHTML = `
                <div class="container">
                    <div class="message-container">
                        <div class="message-type ${messageType.toLowerCase()}">
                            <div class="icon"></div>
                        </div>
                        <p>${message}</p>
                    </div>
                </div>`;

            setTimeout(() => {
                form.classList.add("show");
                setTimeout(() => {
                    form.classList.remove("show");
                    setTimeout(() => {
                        form.innerHTML = "";
                    }, 300);
                }, 3500);
            }, 300);
        }
    }
}